import {isTurboExperimentEnabled} from './behaviors/turbo/utils'
import {ready} from './document-ready'

let container: HTMLElement | null = null

;(async function () {
  await ready
  createNoticeContainer()
})()

// Announce an element's text to the screen reader.
export function announceFromElement(el: HTMLElement) {
  announce(getTextContent(el))
}

// Announce message update to screen reader.
export function announce(message: string) {
  if (isTurboExperimentEnabled()) {
    return setContainerContent(message)
  }

  if (!container || !container.isConnected) {
    /* This condition is for when the aria-live container no longer exists due to nav methods like turbo drive
    which replace the body getting rid of the region. We add the container if it's missing. We then add a delay
    to ensure aria-live can work correctly.

    Note: This approach is not ideal and should be revisited.
    See https://github.com/github/accessibility/issues/1900#issuecomment-1254369320
    */
    createNoticeContainer()
    setTimeout(() => {
      setContainerContent(message)
    }, 200)
  } else {
    setContainerContent(message)
  }
}

// Set aria-live container to message.
function setContainerContent(message: string) {
  if (isTurboExperimentEnabled()) {
    container = document.querySelector('#js-global-screen-reader-notice')
  }

  if (!container) return
  if (container.textContent === message) {
    /* This is a hack due to the way the aria live API works.
    A screen reader will not read a live region again
    if the text is the same. Adding a space character tells
    the browser that the live region has updated,
    which will cause it to read again, but with no audible difference. */
    container.textContent = `${message}\u00A0`
  } else {
    container.textContent = message
  }
}

// Get the global screen reader notice container.
function createNoticeContainer() {
  if (isTurboExperimentEnabled()) return

  container = document.createElement('div')
  container.setAttribute('aria-live', 'polite')
  container.classList.add('sr-only')
  container.setAttribute('data-test-selector', 'aria-live-container')
  document.body.append(container)
}

// Gets the trimmed text content of an element.
function getTextContent(el: HTMLElement): string {
  // innerText does not contain hidden text
  /* eslint-disable-next-line github/no-innerText */
  return (el.getAttribute('aria-label') || el.innerText || '').trim()
}
